<template>
  <page-table />
</template>
<script>
import PageTable from './components/tech-table'
export default {
  name: 'technology-processSheet',
  components: {
    PageTable,
  },
}
</script>
